import * as core from '../../../../../../../core'
import * as spaceSurveyStatus from '../space-survey-func-method'

export const RESOURCE = {
  payload: {
    description: 'Unassignable',
    enumId: core.dms.models.Enum.Id.from({
      partialId: spaceSurveyStatus.RESOURCE.payload.partialId,
    }),
    id: 'UNASSIGNABLE',
    name: 'Unassignable',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
